module.exports = __webpack_public_path__ + "img/404.0c0d89e7.png";